import { Params } from '@angular/router';
import {
  DeliveryInfo,
  Order,
  OrderMaterial,
} from '@epicuro-next/models/order-book';

import { ListPageActions } from './dynamic-actions.model';

export enum OrderMaterialsAdditionalPropertiesKeys {
  InternalId = 'internalId',
  ImageUrl = 'imageUrl',
  OrderDetailsRedirectUrlParams = 'orderDetailsRedirectUrlParams',
  Quantity = 'quantity',
  TrackingAction = 'trackingAction',
  InvoicesAction = 'invoicesAction',
  CSPath = 'csPath',
  OrderTypeFormatted = 'orderTypeFormatted',
  GenderConfig = 'genderConfig',
}

export type OrderMaterialsAdditionalProperties = {
  [OrderMaterialsAdditionalPropertiesKeys.ImageUrl]: string;
  [OrderMaterialsAdditionalPropertiesKeys.Quantity]: string | number;
  [OrderMaterialsAdditionalPropertiesKeys.OrderDetailsRedirectUrlParams]: Params;
  [OrderMaterialsAdditionalPropertiesKeys.TrackingAction]: {
    type: ListPageActions;
    value: DeliveryInfo[];
  };
  [OrderMaterialsAdditionalPropertiesKeys.InvoicesAction]: IInvoiceActionProperty;
  [OrderMaterialsAdditionalPropertiesKeys.CSPath]: string[];
  invoicesEnabled: boolean;
  trackingEnabled: boolean;
  [OrderMaterialsAdditionalPropertiesKeys.OrderTypeFormatted]: string;
};

export type IOrderMaterialWithId = OrderMaterial & {
  [OrderMaterialsAdditionalPropertiesKeys.InternalId]: string;
};

export type IOrderMaterialLine = IOrderMaterialWithId &
  OrderMaterialsAdditionalProperties;

export type IOrderLine = Omit<Order, 'value'> & {
  internalId: string;
  value: string;
  [OrderMaterialsAdditionalPropertiesKeys.OrderDetailsRedirectUrlParams]: Params;
  [OrderMaterialsAdditionalPropertiesKeys.OrderTypeFormatted]: string;
  invoicesEnabled: boolean;
  [OrderMaterialsAdditionalPropertiesKeys.InvoicesAction]: IInvoiceActionProperty;
};

type IInvoiceActionProperty = {
  type: ListPageActions;
  value: Record<string, string>;
};
